// extracted by mini-css-extract-plugin
export var dataCell = "_j6-2";
export var dataRow = "_j6-0";
export var headerRow = "_j6-1";